import types from './actionTypes';

const initialState = {
  loading: false,
  suppliers: [],
  error: '',
};

const supplierReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_SUPPLIER_STATE:
      return initialState;
    case types.CREATE_SUPPLIER.REQUEST:
    case types.UPDATE_SUPPLIER.REQUEST:
    case types.SYNC_SUPPLIERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_SUPPLIER.SUCCESS:
    case types.UPDATE_SUPPLIER.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_SUPPLIERS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        suppliers: [...action.suppliers],
      };
    case types.CREATE_SUPPLIER.FAILURE:
    case types.UPDATE_SUPPLIER.FAILURE:
    case types.SYNC_SUPPLIERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default supplierReducer;
